module.exports = __webpack_public_path__ + "img/QRM-03-1.1ec491ed.png";